import { render, staticRenderFns } from "./WebCrd.vue?vue&type=template&id=519933a0&scoped=true&"
import script from "./WebCrd.vue?vue&type=script&lang=js&"
export * from "./WebCrd.vue?vue&type=script&lang=js&"
import style0 from "./WebCrd.vue?vue&type=style&index=0&id=519933a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519933a0",
  null
  
)

export default component.exports